import dayjs from 'dayjs';
import ExifReader from 'exifreader';

import type { Asset } from '../types/asset';

export const getPlaceholderIcon = (type: string) => {
  let placeholderIcon = '';
  if (type.startsWith('image/')) {
    placeholderIcon = 'fa-file-image';
  } else if (type.startsWith('video/')) {
    placeholderIcon = 'fa-file-video';
  } else if (type.startsWith('audio/')) {
    placeholderIcon = 'fa-file-audio';
  } else {
    placeholderIcon = 'fa-file';
  };
  return placeholderIcon;
};

export const getFileProgress = (file: Asset) => {
  return ((file.progress?.percentage as number) ?? 0) > 0 ?
    Math.round((file.progress?.percentage as number)) :
    0;
};

export const isImageType = (type: string) => type.startsWith('image/');

export const isVideoType = (type: string) => type.startsWith('video/');

export const isAudioType = (type: string) => type.startsWith('audio/');

export const getFileMetadata = async (file: File) => {
  const tags = await ExifReader.load(file);
  const metadata: {
    width: unknown | null;
    height: unknown | null;
    original_date: string | null;
  } = {
    width: tags['Image Width']?.value || null,
    height: tags['Image Height']?.value || null,
    original_date: (tags['DateTimeOriginal']?.description as string | undefined) || null,
  };
  if (metadata.original_date) {
    metadata.original_date = dayjs(metadata.original_date.substring(0, 10).replace(/:/g, '-')).format('YYYY-MM-DD');
  }
  return metadata;
}
